import { create } from "zustand";

const usePlanStore = create(() => ({
  plan: null,
  canPublish: false,
  transaction: null,
  contract: null,
  contractStatus: null,
  contractEndDate: null,
}));

export const usePublishPermissionStore = create((set) => ({
  publishPermission: null,
  setPublishPermission: (publishPermission) => set({ publishPermission }),
}));

export default usePlanStore;
